import TextInput from '../../../../shared/components/inputs/text-input'
import { Button } from '../../../../shared/components/ui/button'
import React from 'react'

function VerificationForm() {
    return (
        <div className="flex flex-col gap-5 w-full">
            <TextInput
                label='Enter code'
                placeholder='Enter you 6-digit PIN'
            />
            <Button className='w-full mt-5'>Verify</Button>
        </div>
    )
}

export default VerificationForm